import { Outlet } from 'react-router-dom';

export default function WebviewLayout() {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* 웹뷰 레이아웃 - 반응형 디자인 */}
      <main className="w-full max-w-screen-xl mx-auto">
        <Outlet />
      </main>
    </div>
  );
}
